import { useCallback } from "react"

import { PROJECT_DETAILS } from "shared/constants/permalinks"

import {
  HistoryResourceType,
  useProjectHistory
} from "entities/projects/api/useProjectHistory"
import { ProjectHistoryEntry } from "entities/projects/types/ProjectHistoryEntry"
import { ProjectHistoryFilterState } from "widgets/project-history/project-history-filter/ProjectHistoryFilter"

export interface ProjectHistoryModel {
  entries: ProjectHistoryEntry[]
  hasMore: boolean
  isLoading: boolean
  loadMore: () => void
  getElementUrl: (entry: ProjectHistoryEntry) => string
}

interface ProjectHistoryModelInput {
  projectID: string
  filterValues: ProjectHistoryFilterState
}

export function useProjectHistoryModel({
  projectID,
  filterValues
}: ProjectHistoryModelInput): ProjectHistoryModel {
  const { entries, isLoading, hasMore, loadMore } = useProjectHistory({
    resourceType: HistoryResourceType.PROJECTS,
    id: projectID,
    lastDays: filterValues.timeFrame || 30
  })

  const getElementUrl = useCallback(
    (entry: ProjectHistoryEntry) =>
      entry.entity?.id
        ? `/${PROJECT_DETAILS}?project_id=${projectID}&element=${entry.entity.id}`
        : `/${PROJECT_DETAILS}?project_id=${projectID}`,
    [projectID]
  )

  return {
    isLoading,
    entries: entries as ProjectHistoryEntry[],
    hasMore,
    loadMore,
    getElementUrl
  }
}
